export default "__VITE_ASSET__JO92EX6J__"